<template>
  <el-input v-bind="$attrs" v-on="$listeners" :style="styles" :size="size"
    @input="$emit('input', $event)" :value="value" class="zt-input"
  >
    <slot name="prefix" slot="prefix"></slot>
    <slot name="suffix" slot="suffix"></slot>
    <slot name="prepend" slot="prepend"></slot>
    <slot name="append" slot="append"></slot>
    <slot></slot>
  </el-input>
</template>

<script>
export default {
  name: 'ZtInput',
  props: {
    width: String,
    minWidth: String,
    maxWidth: String,
    size: String,
    value: [String, Number],
  },

  model: {
    prop: 'value',
    event: 'input' 
  },

  computed: {
    styles() {
      const { width, minWidth, maxWidth } = this
      return { width, minWidth, maxWidth }
    }
  },
}
</script>

<style lang="scss" scoped>
/deep/ .el-input__prefix {
  left: 15px
}
</style>